import { useEffect, useState, useCallback } from "react";
import { PageHeader } from "@/components/DashboardShell";
import { Stat } from "@/components/brand";
import api from "@/lib/api";

export default function DriverEarnings() {
  const [items, setItems] = useState([]);
  const [from, setFrom] = useState("");
  const [to, setTo] = useState("");

  const load = useCallback(async () => {
    const { data } = await api.get("/deliveries", { params: { status: "delivered" } });
    setItems(data);
  }, []);
  useEffect(() => { load(); }, [load]);

  const filtered = items.filter((d) => {
    const t = new Date(d.updated_at);
    if (from && t < new Date(from)) return false;
    if (to && t > new Date(to + "T23:59:59")) return false;
    return true;
  });
  const total = filtered.reduce((s, d) => s + (d.cost || 0), 0);

  return (
    <div>
      <PageHeader index="04" eyebrow="Earnings" title="Earnings & history" />

      <div className="grid grid-cols-2 lg:grid-cols-3 gap-6 border border-gray-200 p-6 mb-8">
        <Stat label="Completed" value={filtered.length} />
        <Stat label="Payout" value={`$${total.toFixed(2)}`} />
        <Stat label="Avg / job" value={filtered.length ? `$${(total / filtered.length).toFixed(2)}` : "$0.00"} />
      </div>

      <div className="flex flex-wrap items-end gap-4 mb-6">
        <div>
          <label className="routa-label">From</label>
          <input type="date" data-testid="earnings-from" value={from} onChange={(e) => setFrom(e.target.value)} className="routa-input" />
        </div>
        <div>
          <label className="routa-label">To</label>
          <input type="date" data-testid="earnings-to" value={to} onChange={(e) => setTo(e.target.value)} className="routa-input" />
        </div>
        {(from || to) && (
          <button onClick={() => { setFrom(""); setTo(""); }} className="font-mono text-[11px] tracking-[0.14em] uppercase text-gray-500 hover:text-[#0a0a0a] pb-3">Clear</button>
        )}
      </div>

      <div className="border border-gray-200 divide-y divide-gray-200" data-testid="earnings-list">
        {filtered.length === 0 && <div className="px-5 py-10 text-center text-sm text-gray-400">No payouts in this range.</div>}
        {filtered.map((d) => (
          <div key={d.id} className="flex items-center justify-between px-5 py-4">
            <div>
              <div className="flex items-center gap-3">
                <span className="font-mono text-[11px] text-gray-400">{d.id.slice(0, 8).toUpperCase()}</span>
                <span className="text-xs text-gray-400">{new Date(d.updated_at).toLocaleDateString()}</span>
              </div>
              <div className="text-sm text-[#0a0a0a] mt-0.5 truncate">{d.dropoff.address}</div>
            </div>
            <div className="text-sm font-semibold text-[#0a0a0a]">+ ${d.cost.toFixed(2)}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
